import DatePicker, { registerLocale } from "react-datepicker"
import { ErrorMessage, Field, Form, Formik } from "formik";
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from "react";
import MultiFieldModal from "./MultiFieldModal";
import ja from 'date-fns/locale/ja'; // ✅ Japanese locale


// Register the locale globally
registerLocale('ja', ja);

const JapaneseResumeForm = ({ initialValues, validationSchema, handleSubmit, role, handleBack }) => {
    const [newChip, setNewChip] = useState('');
    const fileInputRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeModal, setActiveModal] = useState('');
    const [initialModalData, setInitialModalData] = useState([])
    const handleCloseModal = () => {
        setIsModalOpen(false)
        setActiveModal('');
        setInitialModalData([]);
    }

    const acedemicFields = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "start_year", fieldLabel: "開始年", type: "date", placeholder: "開始日を選択してください" },
        { fieldName: "end_year", fieldLabel: "終了年", type: "date", placeholder: "終了日を選択してください" },
        { fieldName: "school_name", fieldLabel: "学校名", type: "text", placeholder: "学校名を入力してください" },
        { fieldName: "license", fieldLabel: "資格", type: "text", placeholder: "資格を入力してください（例：BE）" },
        { fieldName: "expert", fieldLabel: "専門分野", type: "text", placeholder: "専門分野を入力してください" },
    ];
    const familyFields = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "name", fieldLabel: "氏名", type: "text", placeholder: "氏名を入力してください" },
        { fieldName: "relationship", fieldLabel: "関係", type: "text", placeholder: "関係を入力してください" },
        { fieldName: "age", fieldLabel: "年齢", type: "number", placeholder: "年齢を入力してください" },
        { fieldName: "occupation", fieldLabel: "職業", type: "text", placeholder: "職業を入力してください" },
    ];
    const workExperienceFields = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "start_year", fieldLabel: "開始年", type: "date", placeholder: "開始日を選択してください" },
        { fieldName: "end_year", fieldLabel: "終了年", type: "date", placeholder: "終了日を選択してください" },
        { fieldName: "job_description", fieldLabel: "仕事内容", type: "text", placeholder: "仕事内容を入力してください" },
        { fieldName: "equipment_used", fieldLabel: "使用機器", type: "text", placeholder: "使用した機器を入力してください" },
        { fieldName: "company_name", fieldLabel: "会社名", type: "text", placeholder: "会社名を入力してください" },
    ];


    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ values, setFieldValue, errors }) => {
                    const handleAddChip = (fieldName) => {
                        const inputValue = newChip[fieldName];
                        if (inputValue && !values[fieldName].includes(inputValue)) {
                            const updatedValues = [...values[fieldName], inputValue];
                            setFieldValue(fieldName, updatedValues);

                            setNewChip(prev => ({ ...prev, [fieldName]: '' })); // Clear only the relevant field
                        }
                    };

                    // const handleRemoveChip = (fieldName, chipToRemove) => {
                    //     const updatedValues = values[fieldName].filter(chip => chip !== chipToRemove);
                    //     setFieldValue(fieldName, updatedValues);
                    // };
                    const handleRemoveChip = (chipToRemove, fieldName) => {
                        const updatedValues = values[fieldName].filter(chip => chip !== chipToRemove);
                        setFieldValue(fieldName, updatedValues);
                    };

                    // const handleAddChip = () => {
                    //     if (newChip && !values.skill.includes(newChip)) {
                    //         const updatedSkills = [...values.skill, newChip];
                    //         setFieldValue('skill', updatedSkills); // Update Formik state
                    //         setNewChip(''); // Clear local input
                    //     }
                    // };

                    // const handleRemoveChip = (chipToRemove) => {
                    //     const updatedSkills = values.skill.filter(chip => chip !== chipToRemove);
                    //     setFieldValue('skill', updatedSkills); // Update Formik state
                    // };

                    const handleKeyDown = (e, fieldName) => {
                        if (e.key === 'Enter') {
                            e.preventDefault(); // Prevent form submission
                            handleAddChip(fieldName);
                        }
                    };
                    return (
                        <Form>
                            <div className="row">
                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'> 会社名
                                    </label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder='雇用者名を入力してください'
                                        name='employeer_name'
                                        disabled={role === 'management'}
                                    />
                                    <ErrorMessage name='employeer_name' component='div' className="text-danger" />
                                </div>
                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>氏名(姓,名）</label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder='氏名を入力してください'
                                        name='name'
                                        disabled={role === 'management'}
                                    />
                                    <ErrorMessage name='name' component='div' className="text-danger" />
                                </div>

                                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>メール</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter User Email'
                                    name='email'
                                    
                                />
                                <ErrorMessage name='email' component='div' className="text-danger" />
                            </div> */}

                                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>電話番号</label>
                                <Field
                                    type='number'
                                    className='form-control'
                                    placeholder='Enter Phone Number'
                                    name='phone'
                                    
                                />
                                <ErrorMessage name='phone' component='div' className="text-danger" />
                            </div> */}

                                {/* <div className="col-md-4 px-3 py-2">
                                <label className="form-label">スキル</label>
                                <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                                    <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newChip}
                                            onChange={(e) => setNewChip(e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(e, "skill")}
                                            placeholder="Add a chip and press Enter"
                                            
                                        />
                                        <ErrorMessage name='skill' component='div' className="text-danger" />
                                        {values.skill.map((chip, index) => (
                                            <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                                {chip}
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ml-2"
                                                    aria-label="Close"
                                                    onClick={() => handleRemoveChip(chip,"skill")}
                                                    
                                                ></button>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div> */}

                                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Current Salary</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Current Salary'
                                    name='current_salary'
                                     
                                />
                                <ErrorMessage name='current_salary' component='div' className="text-danger" />
                            </div> */}

                                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Expected Salary</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Expected Salary'
                                    name='expected_salary'
                                     
                                />
                                <ErrorMessage name='expected_salary' component='div' className="text-danger" />

                            </div> */}

                                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Status</label>
                                <Field as="select" className='form-select' name="status"   >
                                    <option value="" selected hidden label="Select User Role" />
                                    <option value="Immediate Joiner">Immediate Joiner</option>
                                    <option value="Notice Period">Notice Period</option>
                                </Field >
                                <ErrorMessage name='status' component='div' className="text-danger" />
                            </div> */}

                                {/* {values.status === "Notice Period" && (
                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>Notice period</label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder='Enter notice period'
                                        name='notice_period'
                                         
                                    />
                                    <ErrorMessage name='notice_period' component='div' className="text-danger" />

                                </div>)} */}


                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>性別</label>
                                    <Field as="select" className='form-select' name="sex" disabled={role === 'management'} >
                                        <option value="" selected hidden label="性別を選択してください" />
                                        <option value="男性">男性</option>
                                        <option value="女性">女性</option>
                                        <option value="その他">その他</option>
                                    </Field >
                                    <ErrorMessage name='sex' component='div' className="text-danger" />

                                </div>

                                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Location</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Location'
                                    name='location'
                                     
                                />
                                <ErrorMessage name='location' component='div' className="text-danger" />
                            </div> */}

                                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Preferred </label>
                                <Field as="select" className='form-select' name="mode"   >
                                    <option value="" selected hidden label="Select the Preferred" />
                                    <option value="Remote">Remote</option>
                                    <option value="Work From Office">Work From Office</option>
                                </Field >
                                <ErrorMessage name='mode' component='div' className="text-danger" />
                            </div> */}

                                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>経験（年 </label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Total Experience'
                                    name='years_of_exp'
                                    
                                />
                                <ErrorMessage name='years_of_exp' component='div' className="text-danger" />

                            </div> */}

                                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>言語</label>
                                <Field as="select" className='form-select' name="language"   >
                                    <option value="" selected hidden label="Select User Role" />
                                    <option value="N5">N5</option>
                                    <option value="N4">N4</option>
                                    <option value="N3">N3</option>
                                    <option value="N2">N2</option>
                                    <option value="N1">N1</option>
                                </Field >
                                <ErrorMessage name='language' component='div' className="text-danger" />
                            </div> */}

                                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>履歴書</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    name="file"
                                    onChange={(event) => {
                                        setFieldValue('file', event.target.files[0]);  // Set the file to Formik state
                                    }}
                                    disabled={role === "intermediate" ? true : false}
                                />
                                <ErrorMessage name='file' component='div' className="text-danger" />

                                {values.file && typeof values.file === 'string' && (
                                    <a href={values.file} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                        現在のファイルをダウンロードする
                                    </a>
                                )}
                            </div> */}

                                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>日本語の履歴書</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    name="japanese_file"
                                    onChange={(event) => {
                                        setFieldValue('japanese_file', event.target.files[0]);  // Set the file to Formik state
                                    }}
                                    disabled={role === "hr" ? true : false}

                                />
                                <ErrorMessage name='japanese_file' component='div' className="text-danger" />

                                {values.japanese_file && typeof values.japanese_file === 'string' && (
                                    <a href={values.japanese_file} target="_blank" rel="noopener noreferrer" className="d-block mt-2">
                                        現在のファイルをダウンロードする
                                    </a>
                                )}
                            </div> */}

                                {(role === "admin" || role === 'management') && <>
                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>会社名</label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder='雇用者名を入力してください'
                                            name='employeer_name'
                                            disabled={role === 'management'}
                                        //  
                                        />
                                        <ErrorMessage name='employeer_name' component='div' className="text-danger" />
                                    </div>

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>緊急連絡先 </label>
                                    <Field
                                        type='number'
                                        className='form-control'
                                        placeholder='Enter Emergency Contact Number'
                                        name='emergency_contact'
                                    //  
                                    />
                                    <ErrorMessage name='emergency_contact' component='div' className="text-danger" />
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>ビザ </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="visa"
                                        onChange={(event) => {
                                            setFieldValue('visa', event.target.files[0]);  // Set the file to Formik state
                                        }}
                                    // disabled={role === "hr" ? true: false}

                                    />
                                    <ErrorMessage name='visa' component='div' className="text-danger" />

                                    {values.visa && typeof values.visa === 'string' && (
                                        <a href={values.visa} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                            現在のファイルをダウンロードする
                                        </a>
                                    )}
                                </div> */}



                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>COE </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="coe"
                                        onChange={(event) => {
                                            setFieldValue('coe', event.target.files[0]);  // Set the file to Formik state
                                        }}
                                    // disabled={role === "hr" ? true: false}

                                    />
                                    <ErrorMessage name='coe' component='div' className="text-danger" />

                                    {values.coe && typeof values.coe === 'string' && (
                                        <a href={values.coe} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                            現在のファイルをダウンロードする
                                        </a>
                                    )}
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>航空券 </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="air_ticket"
                                        onChange={(event) => {
                                            setFieldValue('air_ticket', event.target.files[0]);  // Set the file to Formik state
                                        }}
                                    // disabled={role === "hr" ? true: false}

                                    />
                                    <ErrorMessage name='air_ticket' component='div' className="text-danger" />

                                    {values.air_ticket && typeof values.air_ticket === 'string' && (
                                        <a href={values.air_ticket} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                            現在のファイルをダウンロードする
                                        </a>
                                    )}
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>雇用契約 </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="employement_contract"
                                        onChange={(event) => {
                                            setFieldValue('employement_contract', event.target.files[0]);  // Set the file to Formik state
                                        }}
                                    // disabled={role === "hr" ? true: false}

                                    />
                                    <ErrorMessage name='employement_contract' component='div' className="text-danger" />

                                    {values.employement_contract && typeof values.employement_contract === 'string' && (
                                        <a href={values.employement_contract} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                            現在のファイルをダウンロードする
                                        </a>
                                    )}
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>居住者ファイル</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="resident_copy  "
                                        onChange={(event) => {
                                            setFieldValue('resident_copy', event.target.files[0]);  // Set the file to Formik state
                                        }}
                                    // disabled={role === "hr" ? true: false}

                                    />
                                    <ErrorMessage name='resident_copy' component='div' className="text-danger" />

                                    {values.resident_copy && typeof values.resident_copy === 'string' && (
                                        <a href={values.resident_copy} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                            現在のファイルをダウンロードする
                                        </a>
                                    )}
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>パスポート</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="passport_copy "
                                        onChange={(event) => {
                                            setFieldValue('passport_copy', event.target.files[0]);  // Set the file to Formik state
                                        }}
                                    // disabled={role === "hr" ? true: false}

                                    />
                                    <ErrorMessage name='passport_copy' component='div' className="text-danger" />

                                    {values.passport_copy && typeof values.passport_copy === 'string' && (
                                        <a href={values.passport_copy} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                            現在のファイルをダウンロードする
                                        </a>
                                    )}
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>Contact Details  </label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Contact Details  '
                                    name='contact_details'
                                />
                                <ErrorMessage name='contact_details' component='div' className="text-danger" />
                            </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>到着日 </label>
                                    <DatePicker className='form-control' placeholderText='Select Your Arrival Date '
                                        peekNextMonth showMonthDropdown showYearDropdown dropdownMode='select'
                                        dateFormat='dd/MM/yyyy'
                                        selected={values.arrival_date} onChange={(date) => { setFieldValue('arrival_date', date) }}
                                    />
                                    <ErrorMessage name='arrival_date' component='div' className="text-danger" />
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>オプションファイル  </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="option_file"
                                        onChange={(event) => {
                                            setFieldValue('option_file', event.target.files[0]);  // Set the file to Formik state
                                        }}
                                    // disabled={role === "hr" ? true: false}

                                    />
                                    <ErrorMessage name='option_file' component='div' className="text-danger" />

                                    {values.option_file && typeof values.option_file === 'string' && (
                                        <a href={values.option_file} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                            現在のファイルをダウンロードする
                                        </a>
                                    )}
                                </div> */}

                                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>備考 </label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder='Enter remarks '
                                        name='remarks'
                                    //  
                                    />
                                    <ErrorMessage name='remarks' component='div' className="text-danger" />
                                </div> */}



                                </>}

                                {
                                    (role === "admin" || role === "hr" || role === "intermediate") && <>
                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>入学番号</label>
                                        <Field className='form-control' placeholder='Enter Admission Number' name="admission_number"  />
                                        <ErrorMessage name='admission_number' component='div' className="text-danger" />
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>入場料</label>
                                        <Field className='form-control' placeholder='Enter Admission Fee' name="ad_fees"  />
                                        <ErrorMessage name='ad_fees' component='div' className="text-danger" />
                                    </div> */}


                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>入学日</label>
                                        <DatePicker className='form-control' placeholderText='Select Your Date of Admission'
                                            peekNextMonth showMonthDropdown showYearDropdown dropdownMode='select'
                                            dateFormat='dd/MM/yyyy'
                                            selected={values.date_of_admission} onChange={(date) => { setFieldValue('date_of_admission', date) }}
                                            
                                        />
                                        <ErrorMessage name='date_of_admission' component='div' className="text-danger" />
                                    </div> */}


                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>生年月日</label>
                                            <DatePicker className='form-control' placeholderText='生年月日を選択してください' disabled={true}
                                                peekNextMonth showMonthDropdown showYearDropdown dropdownMode='select'
                                                dateFormat='dd/MM/yyyy'
                                                locale="ja"
                                                selected={values.dob} onChange={(date) => { setFieldValue('dob', date) }}

                                            />
                                            <ErrorMessage name='dob' component='div' className="text-danger" />
                                        </div>

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>パスポート番号</label>
                                        <Field className='form-control' placeholder='Enter Passport Number' name="passport_no"  />
                                        <ErrorMessage name='passport_no' component='div' className="text-danger" />
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>国籍</label>
                                        <Field className='form-control' placeholder='Enter Nationality' name="nationality"  />
                                        <ErrorMessage name='nationality' component='div' className="text-danger" />
                                    </div> */}

                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>宗教</label>
                                            <Field className='form-control' placeholder='宗教を入力してください' disabled={role === 'management'}
                                                name="religion" />
                                            <ErrorMessage name='religion' component='div' className="text-danger" />
                                        </div>

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>教育資格</label>
                                        <Field className='form-control' placeholder='Enter Educational Qualification' name="educational_qualification"  />
                                        <ErrorMessage name='educational_qualification' component='div' className="text-danger" />
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>追加資格</label>
                                        <Field className='form-control' placeholder='Enter Additional Qualification' name="additional_qualification"  />
                                        <ErrorMessage name='additional_qualification' component='div' className="text-danger" />
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>婚姻状況</label>
                                        <Field as="select" className='form-select' name='marital_status'  >
                                            <option value="" selected hidden label="Select an option" />
                                            <option value="Married">結婚しました</option>
                                            <option value="UnMarried">未婚</option>
                                        </Field>
                                    </div> */}

                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>身長</label>
                                            <Field className='form-control' type="number" placeholder='身長を入力してください' disabled={true}
                                                name="height" />
                                            <ErrorMessage name='height' component='div' className="text-danger" />
                                        </div>

                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>体重</label>
                                            <Field className='form-control' type="number" placeholder='体重を入力してください' disabled={true}
                                                name="weight" />
                                            <ErrorMessage name='weight' component='div' className="text-danger" />
                                        </div>

                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>現住所</label>
                                            <Field className='form-control' placeholder='現住所を入力してください' disabled={role === 'management'}
                                                name="communication" />
                                            <ErrorMessage name='communication' component='div' className="text-danger" />
                                        </div>

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>参照</label>
                                        <Field className='form-control' placeholder='Enter Reference' name="reference"  />
                                        <ErrorMessage name='reference' component='div' className="text-danger" />
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>英語の知識</label>
                                        <Field as="select" className='form-select' name='english_knowledge'  >
                                            <option value="" selected hidden label="Select an option" />
                                            <option value="Good">良い</option>
                                            <option value="Average">平均</option>
                                            <option value="Poor">貧しい</option>
                                        </Field>
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>フルサイズの写真</label>
                                        <input type="file" className='form-control' placeholder='Enter your photo' onChange={(event) => {
                                            setFieldValue('profile_pic', event.currentTarget.files[0]);
                                        }}  />

                                        {values.profile_pic && (
                                    <div className='mt-2 profileimage'>
                                        {values.profile_pic.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.profile_pic)}
                                                alt="Selected Profile "
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.profile_pic)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )}

                                        {values.profile_pic && typeof values.profile_pic === 'string' && (
                                            <a href={values.profile_pic} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                                現在のファイルをダウンロードする
                                            </a>
                                        )}
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>署名</label>
                                        <input type="file" className='form-control' placeholder='Enter your signature' onChange={(event) => {
                                            setFieldValue('sign', event.currentTarget.files[0]);
                                        }}  />
                                        
                                {values.sign && (
                                    <div className='mt-2 profileimage'>
                                        {values.sign.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.sign)}
                                                alt="Selected Signature"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.sign)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )}

                                        {values.sign && typeof values.sign === 'string' && (
                                            <a href={values.sign} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                                現在のファイルをダウンロードする
                                            </a>
                                        )}
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>教育証明書</label>
                                        <input type="file" className='form-control' placeholder='Enter your name'
                                            onChange={(event) => {
                                                setFieldValue('educationalCertificate', event.currentTarget.files[0]);
                                            }}  />

                                        {values.educationalCertificate && (
                                    <div className='mt-2 profileimage'>
                                        {values.educationalCertificate.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.educationalCertificate)}
                                                alt="Selected educationalCertificate"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.educationalCertificate)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )}

                                        {values.educationalCertificate && typeof values.educationalCertificate === 'string' && (
                                            <a href={values.educationalCertificate} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                                現在のファイルをダウンロードする
                                            </a>
                                        )}
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>医療報告書</label>
                                        <input type="file" className='form-control' placeholder='Enter your name' onChange={(event) => {
                                            setFieldValue('medicalReport', event.currentTarget.files[0]);
                                        }}  />
                                        {values.medicalReport && (
                                    <div className='mt-2 profileimage'>
                                        {values.medicalReport.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.medicalReport)}
                                                alt="Selected medicalReport"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.medicalReport)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )}

                                        {values.medicalReport && typeof values.medicalReport === 'string' && (
                                            <a href={values.medicalReport} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                                現在のファイルをダウンロードする
                                            </a>
                                        )}
                                    </div> */}

                                        {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>ワクチン接種証明書</label>
                                        <input ref={fileInputRef} type="file" className='form-control' placeholder='Enter your name'
                                            onChange={(event) => {
                                                setFieldValue('vaccinationCertificate', event.currentTarget.files[0]);
                                            }}
                                            
                                        />
                                        {values.vaccinationCertificate && (
                                    <div className='mt-2 profileimage'>
                                        {values.vaccinationCertificate.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.vaccinationCertificate)}
                                                alt="Selected vaccinationCertificate"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.vaccinationCertificate)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )}

                                        {values.vaccinationCertificate && typeof values.vaccinationCertificate === 'string' && (
                                            <a href={values.vaccinationCertificate} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}>
                                                現在のファイルをダウンロードする
                                            </a>
                                        )}
                                    </div> */}
                                    </>
                                }

                                <>
                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>年齢</label>
                                        <Field className='form-control' type="number" placeholder='年齢を入力してください' disabled={true}
                                            name="age" />
                                        <ErrorMessage name='age' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>出生地</label>
                                        <Field className='form-control' placeholder='出生地を入力してください' disabled={role === 'management'}
                                            name="place_of_birth" />
                                        <ErrorMessage name='place_of_birth' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>志望動機</label>
                                        <Field className='form-control' placeholder='志望動機を入力してください' disabled={role === 'management'}
                                            name="reason_for_apply" />
                                        <ErrorMessage name='reason_for_apply' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>協同生活</label>
                                        <Field className='form-control' placeholder='協同生活を入力してください' disabled={role === 'management'}
                                            name="cooperative_living" />
                                        <ErrorMessage name='cooperative_living' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>得意な科目</label>
                                        <Field className='form-control' placeholder='得意な科目を入力してください' disabled={role === 'management'}
                                            name="favorite_subject" />
                                        <ErrorMessage name='favorite_subject' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>免許・資格</label>
                                        <Field className='form-control' placeholder='免許・資格を入力してください' disabled={role === 'management'}
                                            name="licenses_and_qualifications" />
                                        <ErrorMessage name='licenses_and_qualifications' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>入れ墨</label>
                                        <Field as="select" className='form-select' name="tattoo" disabled={true} >
                                            <option value="" selected hidden label="選択してください" />
                                            <option value="Yes">はい</option>
                                            <option value="No">いいえ</option>
                                        </Field >
                                        <ErrorMessage name='tattoo' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>血液型</label>
                                        <Field className='form-control' placeholder='血液型を入力してください' disabled={true}
                                            name="blood_type" />
                                        <ErrorMessage name='blood_type' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>右 視力</label>
                                        <Field className='form-control' placeholder='右 視力を入力してください' disabled={true}
                                            name="right_vision" />
                                        <ErrorMessage name='right_vision' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>左 視力</label>
                                        <Field className='form-control' placeholder='左 視力を入力してください' disabled={true}
                                            name="left_vision" />
                                        <ErrorMessage name='left_vision' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>色盲</label>
                                        <Field className='form-control' placeholder='色盲を入力してください' disabled={role === 'management'}
                                            name="color_blindness" />
                                        <ErrorMessage name='color_blindness' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>血圧</label>
                                        <Field className='form-control' placeholder='血圧を入力してください' disabled={role === 'management'}
                                            name="blood_pressure" />
                                        <ErrorMessage name='blood_pressure' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>利き手</label>
                                        <Field className='form-control' placeholder='利き手を入力してください' disabled={role === 'management'}
                                            name="dominant_hand" />
                                        <ErrorMessage name='dominant_hand' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className="form-label">食べられないもの</label>
                                        <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                                            <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    // value={newChip}
                                                    disabled={role === 'management'}
                                                    value={newChip['foods_cannot_eat'] || ''}
                                                    onChange={(e) => setNewChip((prev) => ({ ...prev, foods_cannot_eat: e.target.value }))}
                                                    onKeyDown={(e) => handleKeyDown(e, "foods_cannot_eat")}
                                                    placeholder="チップを追加してエンターキーを押してください"

                                                />
                                                <ErrorMessage name='foods_cannot_eat' component='div' className="text-danger" />
                                                {values.foods_cannot_eat.map((chip, index) => (
                                                    <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                                        {chip}
                                                        <button
                                                            type="button"
                                                            disabled={role === 'management'}
                                                            className="btn-close btn-close-white ml-2"
                                                            aria-label="Close"
                                                            onClick={() => handleRemoveChip(chip, "foods_cannot_eat")}

                                                        ></button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>喫煙</label>
                                        <Field as="select" className='form-select' name="smoking" disabled={true} >
                                            <option value="" selected hidden label="選択してください" />
                                            <option value="Yes">はい</option>
                                            <option value="No">いいえ</option>
                                        </Field >
                                        <ErrorMessage name='smoking' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>飲酒・ビール</label>
                                        <Field as="select" className='form-select' name="drinking_beer" disabled={true} >
                                            <option value="" selected hidden label="選択してください" />
                                            <option value="Yes">はい</option>
                                            <option value="No">いいえ</option>
                                        </Field >
                                        <ErrorMessage name='drinking_beer' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className="form-label">趣味</label>
                                        <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                                            <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    // value={newChip}
                                                    disabled={role === 'management'}
                                                    value={newChip['hobbies'] || ''}
                                                    onChange={(e) => setNewChip((prev) => ({ ...prev, hobbies: e.target.value }))}
                                                    onKeyDown={(e) => handleKeyDown(e, "hobbies")}
                                                    placeholder="チップを追加してエンターキーを押してください"

                                                />
                                                <ErrorMessage name='hobbies' component='div' className="text-danger" />
                                                {values.hobbies.map((chip, index) => (
                                                    <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                                        {chip}
                                                        <button
                                                            type="button"
                                                            className="btn-close btn-close-white ml-2"
                                                            aria-label="Close"
                                                            onClick={() => handleRemoveChip(chip, "hobbies")}
                                                            disabled={role === 'management'}
                                                        ></button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className="form-label">長所</label>
                                        <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                                            <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    // value={newChip}
                                                    disabled={role === 'management'}
                                                    value={newChip['strengths'] || ''}
                                                    onChange={(e) => setNewChip((prev) => ({ ...prev, strengths: e.target.value }))}
                                                    onKeyDown={(e) => handleKeyDown(e, "strengths")}
                                                    placeholder="チップを追加してエンターキーを押してください"

                                                />
                                                <ErrorMessage name='strengths' component='div' className="text-danger" />
                                                {values.strengths.map((chip, index) => (
                                                    <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                                        {chip}
                                                        <button
                                                            type="button"
                                                            className="btn-close btn-close-white ml-2"
                                                            aria-label="Close"
                                                            onClick={() => handleRemoveChip(chip, "strengths")}
                                                            disabled={role === 'management'}
                                                        ></button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className="form-label">短所 </label>
                                        <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                                            <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    // 
                                                    disabled={role === 'management'}
                                                    value={newChip['weaknesses'] || ''}
                                                    onChange={(e) => setNewChip((prev) => ({ ...prev, weaknesses: e.target.value }))}
                                                    onKeyDown={(e) => handleKeyDown(e, "weaknesses")}
                                                    placeholder="チップを追加してエンターキーを押してください"

                                                />
                                                <ErrorMessage name='weaknesses' component='div' className="text-danger" />
                                                {values.weaknesses.map((chip, index) => (
                                                    <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                                        {chip}
                                                        <button
                                                            type="button"
                                                            className="btn-close btn-close-white ml-2"
                                                            aria-label="Close"
                                                            onClick={() => handleRemoveChip(chip, "weaknesses")}
                                                            disabled={role === 'management'}
                                                        ></button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>病歴</label>
                                        <Field className='form-control' placeholder='病歴を入力してください' disabled={role === 'management'}
                                            name="medical_history" />
                                        <ErrorMessage name='medical_history' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>配偶者</label>
                                        <Field as="select" className='form-select' name="spouse" disabled={true} >
                                            <option value="" selected hidden label="選択してください" />
                                            <option value="Yes">はい</option>
                                            <option value="No">いいえ</option>
                                        </Field >
                                        <ErrorMessage name='spouse' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'> 配偶者の名前</label>
                                        <Field as="select" className='form-select' name="language" disabled={true}  >
                                            <option value="" selected hidden label="ユーザーの役割を選択" />
                                            <option value="N5">N5</option>
                                            <option value="N4">N4</option>
                                            <option value="N3">N3</option>
                                            <option value="N2">N2</option>
                                            <option value="N1">N1</option>
                                        </Field >
                                        <ErrorMessage name='language' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>本人収入</label>
                                        <Field className='form-control' type="number" placeholder="個人収入を入力してください" disabled={true}
                                            name="personal_income" />
                                        <ErrorMessage name='personal_income' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>家族収入</label>
                                        <Field className='form-control' type="number" placeholder='家族収入を入力してください' disabled={true}
                                            name="family_income" />
                                        <ErrorMessage name='family_income' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>在日親戚</label>
                                        <Field as="select" className='form-select' name="relatives_in_japan" disabled={true}  >
                                            <option value="" selected hidden label="選択してください" />
                                            <option value="Yes">はい</option>
                                            <option value="No">いいえ</option>
                                        </Field >
                                        <ErrorMessage name='relatives_in_japan' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>在日住所(県)</label>
                                        <Field className='form-control' placeholder="住所を入力してください" disabled={role === 'management'}
                                            name="japanese_address" />
                                        <ErrorMessage name='japanese_address' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>来日経験</label>
                                        <Field className='form-control' placeholder="来日経験を入力してください" type="number" disabled={true}
                                            name="experience_coming_to_japan" />
                                        <ErrorMessage name='experience_coming_to_japan' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>日本で働きたい年数</label>
                                        <Field className='form-control' placeholder="年齢を入力してください" type="number" disabled={true}
                                            name="desired_years_to_work_in_japan" />
                                        <ErrorMessage name='desired_years_to_work_in_japan' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>貯金（年間）</label>
                                        <Field className='form-control' type="number" placeholder="貯金額を入力してください" name="savings_per_year" disabled={true} />
                                        <ErrorMessage name='savings_per_year' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>帰国後の予定・目的</label>
                                        <Field className='form-control' placeholder="目標を入力してください" name="plans_or_goals_after_returning" disabled={role === 'management'} />
                                        <ErrorMessage name='plans_or_goals_after_returning' component='div' className="text-danger" />
                                    </div>
                                </>
                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>学歴詳細</label>
                                    <div>
                                        {
                                            values['academic_details'].length > 0 ? (
                                                <>
                                                    <button type="button" className="btn btn-warning me-2"
                                                        onClick={() => {
                                                            setInitialModalData(values['academic_details'] ?? []);
                                                            setIsModalOpen(true);
                                                            setActiveModal('academic_details');
                                                        }}
                                                    >
                                                       {role === 'management' ? "学歴を見る" : "学歴を更新"}
                                                    </button>
                                                </>
                                            ) :
                                                <button type="button" className="btn btn-success"
                                                    onClick={() => {
                                                        setIsModalOpen(true)
                                                        setActiveModal('academic_details')
                                                    }}>
                                                    {role === 'management' ? "学歴を見る" : "学歴を追加"}
                                                </button>
                                        }

                                    </div>
                                </div>

                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>家族情報</label>
                                    <div>
                                        {
                                            values['family_details'].length > 0 ? (
                                                <>
                                                    <button type="button" className="btn btn-warning me-2"
                                                        onClick={() => {
                                                            setInitialModalData(values['family_details'] ?? []);
                                                            setIsModalOpen(true);
                                                            setActiveModal('family_details');
                                                        }}
                                                    >
                                                        {role === 'management' ? "家族情報を見る" : "家族情報を更新"}
                                                    </button>
                                                </>
                                            ) :
                                                <button type="button" className="btn btn-success"
                                                    onClick={() => {
                                                        setIsModalOpen(true)
                                                        setActiveModal('family_details')
                                                    }}>
                                                { role === 'management' ? "家族情報を見る" : "家族情報を追加" }
                                                </button>
                                        }

                                    </div>
                                </div>

                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>職務経歴</label>
                                    <div>
                                        {
                                            values['work_experience_list'].length > 0 ? (
                                                <>
                                                    <button type="button" className="btn btn-warning me-2"
                                                        onClick={() => {
                                                            setInitialModalData(values['work_experience_list'] ?? []);
                                                            setIsModalOpen(true);
                                                            setActiveModal('work_experience_list');
                                                        }}
                                                    >
                                                        {/* 職務経歴を更新 */}
                                                        {role === 'management' ? "職務経歴を見る" : "職務経歴を更新"}
                                                    </button>
                                                </>
                                            ) :
                                                <button type="button" className="btn btn-success"
                                                    onClick={() => {
                                                        setIsModalOpen(true)
                                                        setActiveModal('work_experience_list')
                                                    }}>
                                                    {/* 職務経歴を追加 */}
                                                    {role === 'management' ? "職務経歴を見る" : "職務経歴を追加"}
                                                </button>
                                        }
                                    </div>
                                </div>


                                <div className="col-md-4 px-3 py-2">
                                    {values.japanese_pdf && <label className='form-label'>
                                        日本語PDF
                                    </label>}
                                    {/* <input type="file" className='form-control' placeholder='File'
                                            onChange={(event) => {
                                                setFieldValue('english_pdf', event.currentTarget.files[0]);
                                            }} disabled={role === 'intermediate'} /> */}

                                    {
                                        values.japanese_pdf && typeof values.japanese_pdf === 'string' ? (
                                            values.japanese_pdf.includes('.pdf') ? (
                                                <embed src={values.japanese_pdf} type='application/pdf' width='100%' />
                                            ) : (
                                                <img src={values.japanese_pdf} alt='candidatePdf' />
                                            )
                                        ) : null
                                    }

                                    {values.japanese_pdf && typeof values.japanese_pdf === 'string' && (
                                        <a href={values.japanese_pdf} target="_blank" rel="noopener noreferrer" >
                                            現在のファイルをダウンロード
                                        </a>
                                    )}
                                    {(isModalOpen && activeModal === "academic_details") && (
                                        <MultiFieldModal key={activeModal} disabled={role === 'management'} handleCloseModal={handleCloseModal} fields={acedemicFields} containerFieldName={"academic_details"} modalTitle={role === 'management' ? "教育を見る" :
                                            "学歴を追加"} setFieldValue={setFieldValue} initialData={initialModalData} />
                                    )}

                                    {(isModalOpen && activeModal === "family_details") && (
                                        <MultiFieldModal key={activeModal} disabled={role === 'management'} handleCloseModal={handleCloseModal} fields={familyFields} containerFieldName={"family_details"} modalTitle={role === 'management' ? "家族情報の表示" : "家族情報を追加"} setFieldValue={setFieldValue} initialData={initialModalData} />
                                    )}

                                    {(isModalOpen && activeModal === "work_experience_list") && (
                                        <MultiFieldModal key={activeModal} disabled={role === 'management'} handleCloseModal={handleCloseModal} fields={workExperienceFields} containerFieldName={"work_experience_list"} modalTitle={role === 'management' ? "職歴を見る" : "職務経歴を追加"} setFieldValue={setFieldValue} initialData={initialModalData} />
                                    )}
                                </div>
                                <div className="row mt-3" hidden={role === 'management'}>
                                    <div className="col ">

                                        <button className='cancel-button ms-2' onClick={handleBack} type='button'>キャンセル</button>
                                        <button className="btn defult-button ms-2" type='submit'>提出する</button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </>
    )
}

export default JapaneseResumeForm